import { useMutation } from "react-query";
import { getProfitAndLossReport } from "../../../services/report";

// Custom hook to get profit and loss report using mutation
export const useReportMutation = () => {
  return useMutation((data) => getProfitAndLossReport(data));
};
